import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import FixedRoundButton from '../../../components/actions/FixedRoundButton'

const AddNewButton = () => {
  let hasAddPermission = useSessionPermission('createSegment')
  if (!hasAddPermission) return false

  return <FixedRoundButton to="/segmentations/new" />
}

export default AddNewButton
